/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListPricingAnalyticsExport } from '../../models/api-response-list-pricing-analytics-export';

export interface ExportPricingAnalytics$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  startDate: string;
  endDate: string;
  granularity: string;
}

export function exportPricingAnalytics(http: HttpClient, rootUrl: string, params: ExportPricingAnalytics$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListPricingAnalyticsExport>> {
  const rb = new RequestBuilder(rootUrl, exportPricingAnalytics.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.query('granularity', params.granularity, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListPricingAnalyticsExport>;
    })
  );
}

exportPricingAnalytics.PATH = '/v1/api/ui/meta-pricing-analytics';
